import { render, staticRenderFns } from "./Large-3.vue?vue&type=template&id=21a20140"
import script from "./Large-3.vue?vue&type=script&lang=js"
export * from "./Large-3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports